/**
 * Error that can be thrown if a fetch returns an invalid response
 */
export default class FetchError extends Error {
    constructor(message, response) {
        super(message);

        this.response = response;
    }
}
